export function newFeedbackObject() {
  this.name = null,
  this.feedback = null,
  this.photoURL = null,
  this.designation = null
}